import { defineComponent, ref, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import Breadcrumbs from '@/components/breadcrumbs'
import RightMenu from '@/components/right-menu'
import Search from '@/components/search'
import Select from '@/components/select'
import OrderItems from './components/order-items/index'
import Logout from '@/components/logout'
import MobileMenu from '@/components/mobile-menu'
import ShowMore from '@/components/show-more'
import EmptyList from '@/components/empty-list/index'
import axios from '@/axios'
import { host } from '@/const'
import './styles/style.sass'
import BetaVersion from "@/components/beta-version";

// interface PerPage {
//   page: number,
//   per_page: number,
//   status?: string
// }

export default defineComponent({
  setup () {
    const orders: unknown = ref([])
    const company: unknown = ref([])
    const statuses = ref([])
    const selectValueForCompany: unknown = ref([{ title: 'Все Компании', value: 'all_company' }])
    const selectValueForStatuses: unknown = ref([{ title: 'Все', value: 'all_statuses' }])
    const ordersPage = ref(1)
    const orderTotal = ref(1)
    const reqParams = ref({
      page: 1,
      per_page: 2,
      status: '',
      company: ''
    })
    const router = useRouter()

    onBeforeMount(async () => {
      const promises = [
        axios.get(`${host}/api/v1/orders`, { params: reqParams.value }),
        axios.get(`${host}/api/v1/client/company`),
        axios.get(`${host}/api/v1/invoice/statuses`)
      ]
      const [ordersItem, companyItem, statusesItem] = await Promise.all(promises)
      // @ts-ignore
      orders.value = ordersItem.data.items
      orderTotal.value = Number(ordersItem.data.total)
      // @ts-ignore
      company.value = companyItem.data.items
      statuses.value = statusesItem.data.items

      // @ts-ignore
      company.value.map((item: Record<string, string>) => {
        // @ts-ignore
        selectValueForCompany.value.push({ title: item.name, value: item.id })
      })

      statuses.value.map((item: Record<string, string>) => {
        // @ts-ignore
        selectValueForStatuses.value.push({ title: item.title, value: item.id })
      })
      // selectValueForStatuses.value = statuses.value.filter((item: any) => item.name === 'payment' || item.name === 'in_work')
    })

    function showMoreResult(value: Event) {
      // @ts-ignore
      orders.value.push(...value.items)
      // @ts-ignore
      ordersPage.value = Number(value.page)
      reqParams.value.page = ordersPage.value
    }

    // const selectValueForStatuses = [
    //   { title: 'Все заявки', value: 'all' },
    //   { title: 'Оплаченные', value: '16a13eca-26f3-44f0-8c89-e1005b349ffb' },
    //   { title: 'Неоплаченные', value: 'noPayment' }
    // ]
    async function ordersFilterForStatus(value: Event) {
      // @ts-ignore
      reqParams.value.status = value.value
      // @ts-ignore
      if (value.value === 'all_statuses') reqParams.value.status = ''
      reqParams.value.page = 1
      const result = (await axios.get(`${host}/api/v1/orders`, { params: reqParams.value })).data
      // @ts-ignore
      orders.value = result.items
      orderTotal.value = result.total
      await router.push({name: 'orders', query: {filter: reqParams.value.status}})

      // let result = null
      // switch (value.title) {
      //   case 'Оплаченные':
      //     reqParams.value.status = value.value
      //     reqParams.value.page = 1
      //     result = (await axios.get(`${host}/api/v1/orders`, { params: reqParams.value })).data
      //     orders.value = result.items
      //     orderTotal.value = result.total
      //     router.push({ name: 'orders', query: { filter: 'payment' } })
      //     break
      //   case 'Все заявки':
      //     reqParams.value.status = ''
      //     reqParams.value.page = 1
      //     result = (await axios.get(`${host}/api/v1/orders`, { params: reqParams.value })).data
      //     orders.value = result.items
      //     orderTotal.value = result.total
      //     router.push({ name: 'orders', query: { filter: 'all' } })
      //     break
      // }
    }

    async function ordersFilterForCompany(value: Event) {
      // @ts-ignore
      reqParams.value.company = value.value
      // @ts-ignore
      if (value.value === 'all_company') reqParams.value.company = ''
      reqParams.value.page = 1
      const result = (await axios.get(`${host}/api/v1/orders`, { params: reqParams.value })).data
      // @ts-ignore
      orders.value = result.items
      orderTotal.value = result.total
      await router.push({name: 'orders', query: {filter: reqParams.value.company}})
    }

    async function ordersSearch (number: string) {
      let result = null
      if (!number) result = (await axios.get(`${host}/api/v1/orders`, { params: reqParams.value })).data
      else result = (await axios.get(`${host}/api/v1/orders`, { params: { number: number.trim() } })).data
      if (result.items.length === 0) return
      // @ts-ignore
      orders.value = result.items
      orderTotal.value = result.total
      await router.push({name: 'orders', query: {search: number.trim()}})
      console.log('ordersSearch', number)
    }

    return () => {
      return (
        <div class="orders-page">
          <Breadcrumbs items={[{ name: 'Главная', link: '/' }, { name: 'История заявок', link: '#' }]}/>
          <BetaVersion />
          <h1 class="page-title">История заявок</h1>
          <h4>Информация о сделанных заявках может отображаться не сразу, пожалуйста подождите</h4>
          <div class="main-content-two-columns">
            <div>
              <div class="orders-filters">
                <Search
                  styleClass="grey"
                  placeholder="Введите номер заявки"
                  onInput={(e: Event) => ordersSearch((e.target as HTMLFormElement).value)}
                />

                {// @ts-ignore
                  selectValueForStatuses.value.length > 0 ? (
                  <Select
                    class="orders-filters-select"
                    options={// @ts-ignore
                      selectValueForStatuses.value
                    }
                    value={// @ts-ignore
                      selectValueForStatuses.value[0].title
                    }
                    onSelectChange={(e: Event) => { ordersFilterForStatus(e) }}
                  />
                ) : null }

                {// @ts-ignore
                  selectValueForCompany.value.length > 0 ? (
                  <div class="orders-filter-company">
                    <span>Компания</span>
                    <Select
                      class="orders-filters-select"
                      options={// @ts-ignore
                        selectValueForCompany.value
                      }
                      value={// @ts-ignore
                        selectValueForCompany.value[0].title
                      }
                      onSelectChange={(e: Event) => { ordersFilterForCompany(e) }}
                    />
                  </div>
                ) : null }
              </div>

              {// @ts-ignore
                orders.value.length > 0
                ? (
                  <div>
                    <OrderItems ordersItems={// @ts-ignore
                      orders.value
                    } />
                    <ShowMore
                      class="show-more-orders"
                      apiEndpoint='/api/v1/orders'
                      reqParams={reqParams.value}
                      onShowMoreItem={(e: Event) => { showMoreResult(e) }}
                      total={orderTotal.value}
                    />
                  </div>)
                : (<EmptyList/>)
              }
            </div>

            <div class="main-content-two-columns-right">
              <div class="main-content-two-columns-right-elem-sticky">
                <RightMenu/>
                <Logout/>
                <MobileMenu/>
              </div>
            </div>
          </div>
        </div>
      )
    }
  }
})